/** @deprecated Use useDietaryTags hook instead */
export const DIETARY_TAGS = [
  "gluten_free",
  "vegan",
  "vegetarian",
  "dairy_free",
  "nut_free",
  "halal",
  "kosher",
] as const;

/** @deprecated Use useDietaryTags hook instead */
export type DietaryTag = string;

/** @deprecated Use useDietaryTags hook instead */
export const DIETARY_TAG_LABELS: Record<string, string> = {
  gluten_free: "Gluten-Free",
  vegan: "Vegan",
  vegetarian: "Vegetarian",
  dairy_free: "Dairy-Free",
  nut_free: "Nut-Free",
  halal: "Halal",
  kosher: "Kosher",
};

/** @deprecated Use usePricingTypes hook instead */
export const PRICING_TYPES = ["per_plate", "per_pan", "per_person", "per_dozen"] as const;
export type PricingType = (typeof PRICING_TYPES)[number];

/** @deprecated Use usePricingTypes hook instead */
export const PRICING_TYPE_LABELS: Record<string, string> = {
  per_plate: "Per Plate",
  per_pan: "Per Pan",
  per_person: "Per Person",
  per_dozen: "Per Dozen",
};

export interface MenuCategory {
  id: string;
  name: string;
  description: string | null;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface MenuItemPrice {
  id: string;
  menu_item_id: string;
  pricing_type: PricingType;
  price: number;
  label: string | null;
  serves: number | null;
  sku: string | null;
  created_at: string;
}

export interface MenuItem {
  id: string;
  category_id: string;
  name: string;
  description: string | null;
  image_url: string | null;
  is_active: boolean;
  dietary_tags: string[];
  sku: string | null;
  abbreviation: string | null;
  square_catalog_id: string | null;
  created_at: string;
  updated_at: string;
  category?: MenuCategory;
  prices?: MenuItemPrice[];
}

export type MenuItemSortKey = "name" | "category" | "price";
export type MenuItemSortDir = "asc" | "desc";
